import styled from "@emotion/styled";
import type { FC } from "react";
import { useMemo } from "react";

import { ReactComponent as BalanceIcon } from "../../../assets/balances.svg";
import { useStarAtlasOrders } from "../../../hooks/dex/useStarAtlasOrders";
import type { CollapseControlProps } from "../../../hooks/home/useCollapseControl";
import { useOpenbookOrdersQuery } from "../../../hooks/queries/dex/useOpenbookOrdersQuery";
import { ChevronCollapse } from "../ChevronCollapse/ChevronCollapse";
import { OpenOrdersTable, UnsettledBalancesTable } from "./Openbook";
import { StarAtlasOpenOrdersTable } from "./StarAtlas";

export const DEXGrid: FC<CollapseControlProps> = ({ activePanels, getPanelKey, onPanelClick }) => {
  const { data: openBookData, status: openBookStatus } = useOpenbookOrdersQuery();

  const starAtlasOrders = useStarAtlasOrders();

  const starAtlasOrdersValue = useMemo(() => {
    return starAtlasOrders.reduce<number>((acc, order) => {
      return acc + (order.valueInUSD ?? 0);
    }, 0);
  }, [starAtlasOrders]);

  return (openBookStatus === "success" &&
    (openBookData.orders.length > 0 || openBookData.unsettledBalances.length > 0)) ||
    starAtlasOrders.length > 0 ? (
    <StyledChevronCollapse
      activePanels={activePanels}
      panelKey={getPanelKey("DEXGrid")}
      onChange={onPanelClick}
      title="DEX"
      value={
        (openBookData?.totalUnsettledValueUSD ?? 0) + (openBookData?.totalOrdersValueUSD ?? 0) + starAtlasOrdersValue
      }
      TitleIcon={BalanceIcon}
    >
      <>
        {openBookStatus === "success" && openBookData.orders.length > 0 && (
          <OpenOrdersTable openOrdersValue={openBookData.totalOrdersValueUSD} orders={openBookData.orders} />
        )}
        {starAtlasOrders.length > 0 && <StarAtlasOpenOrdersTable openOrders={starAtlasOrders} />}
        {openBookStatus === "success" && openBookData.unsettledBalances.length > 0 && (
          <UnsettledBalancesTable
            unsettledBalanceList={openBookData.unsettledBalances}
            unsettledBalancesValue={openBookData.totalUnsettledValueUSD}
          />
        )}
      </>
    </StyledChevronCollapse>
  ) : (
    <></>
  );
};

const StyledChevronCollapse = styled(ChevronCollapse)`
  margin-top: 20px;
`;
